<template>
    <div class="">
        <div class="">
            <h2>Verification</h2>
            <h4 class="text-center mt-3">Security Questions</h4>
            <div v-for="(quizElement, indexQuestion) in this.interactiveQuery" :key="indexQuestion" class="px-4 mt-4">
                <p class="fw-bold">{{quizElement.question}}</p>
                <div class="form-check mb-2" v-for="(option, key, indexOption) in quizElement.options" :key="key">
                    <label class="form-check-label" :for="'option' + '-' + indexQuestion + '-' + key">
                        <input class="form-check-input" type="radio" :name="'option' + '-' + indexQuestion" :id="'option' + '-' + indexQuestion + '-' + key"
                        @change="this.selectAnswer(parseInt(indexQuestion), parseInt(indexOption) + 1)"/>
                        {{option}}
                    </label>
                </div>
            </div>
            <!-- action bottons section -->
            <div class="d-grid gap-2 d-md-flex justify-content-md-center">
                <div class="d-grid gap-2 col-8 col-md-2 mx-auto">
                    <a v-if="this.showSkipVerification"
                        class="btn btn-lg btn-light"
                        id="btnSkip"
                        @click.prevent="this.executeSkipVerification">Skip</a>
                        
                    <a class="btn btn-lg"
                        :class="[this.isQuizCompleted ? 'btn-primary' : 'btn-secondary disabled']"
                        :disabled="!this.isQuizCompleted"
                        id="btnNext" 
                        @click.prevent="this.getVerified">Next</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Quiz',
    emits: ["getVerified","update:application-settings"],
    components: {},
    props: {
        quiz: {
            type: Object,
            required: true,
        },
        applicationSettings: {
            type: Object,
            required: true,
        },
        showSkipVerification: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data: () => {
        let questionsWithAnswers = {};
        let errors = null;
        let isLoading = false;

        return {
            questionsWithAnswers,
            errors,
            isLoading,
        };
    },
    methods: {
        selectAnswer(question, answer) {
            this.questionsWithAnswers[question] = answer;
        },
        executeSkipVerification() {
            this.applicationSettings.notifications.error = {};
            this.applicationSettings.notifications.success = {};
            this.applicationSettings.userWantsVerification = false;
        },
        getVerified() {
            // let's scroll to the top as the page does not refresh and remembers its last position after every step
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            
            if(this.isQuizCompleted) {
                const answers = Object.fromEntries(Object.entries(this.questionsWithAnswers).map(([key, val]) => [key, val]));
                let payload = {
                    transaction_key : this.quiz.transactionKey,
                    answers
                };
                this.$emit("getVerified", payload);
            }
        }
    },
    computed: {
        isQuizCompleted() {
            return this.questionsWithAnswers && (Object.values(this.questionsWithAnswers).length > 2);
        },
        interactiveQuery() {
            return !!this.quiz.interactiveQuery ? Object.values(this.quiz.interactiveQuery)[0] : null;
        }
    },
    created() {
        // console.log('Quiz component created');
    },
    mounted() {
        // console.log('Quiz component mounted');
    },
    watch: {
    }

};
</script>